import * as React from 'react';
import { WFormsTableWrapper } from '../../../core/table/WFormsTableWrapper';
import { IDs } from '../../../helpers/IDs';
import { TriggerService } from '../../../core/trigger/trigger_service';
import { lazyInject } from '../../../services/inversify';

export interface StandorteEnergietraegerProps {
    standortSelected: any;
}

export interface StandorteEnergietraegerState {
    dataLoaded: Array<any>;
}

export class StandorteEnergietraeger extends React.Component<StandorteEnergietraegerProps, StandorteEnergietraegerState> {

    constructor(props: any) {
        super(props);
        this.state = {
            dataLoaded: undefined
        };
        this.onFormChange = this.onFormChange.bind(this);
        this.preFilter = this.preFilter.bind(this);
        this.validateField = this.validateField.bind(this);
    }
    @lazyInject(TriggerService) private triggerService: TriggerService;

    onFormChange(WFormData: any) {
       //  WFormData.setValue('datum', Moment().unix());
    }

    preFilter(data: Array<any>) {
        const { standortSelected } = this.props;
        return standortSelected
            ? data
                .filter((item: any) => (
                    item.standort_tid_orig
                    && +item.standort_tid_orig === standortSelected.tid
                ))
            : data;
    }

    render() {

        const { standortSelected } = this.props;
        return (
            <div>
                <WFormsTableWrapper
                    entity={IDs.ENT_STANDORT_ENERGIETRAEGER}
                    module={IDs.MOD_ETOOL}
                    actions={['add', 'edit', 'delete']}
                    customClass={'Custom-ETA'}
                    formLayout={'flowV2'}
                    formPreset = {{ standort_tid: standortSelected.tid}}
                    onDataLoaded = {(dataLoaded: Array<any>) => this.setState({dataLoaded})}
                    customFormConfig={{
                        standort_tid: {
                            readonly: true
                        }
                    }}
                    validateField = {this.validateField}
                    // externalHeaderElements = {[knopf_beleuchtung]}
                    onFormChange={this.onFormChange}
                    preFilterFunction={this.preFilter}
                    onSaveDone={() => this.triggerService.fire('reload', IDs.ENT_STANDORT_ENERGIETRAEGER)}
                />
           </div>
        );
    }
    validateField(key: string, value: any, data: any, onValueChange: (name: string, value: any) => void) {
        if (key === 'energiedaten_waerme_energietraeger_tid' && this.state.dataLoaded) {
            console.log('Valid', this.state.dataLoaded, value);
            // Wir suchen nach einem Datensatz mit dem gleichen Energieträger am gleichen Standort aber einer anderen TID
            // Achtung. Wir müssen an hier auf "_orig" zugreifen, da die Daten in der Tabelle im Modus "resolved" geladen werden.
            if (this.state.dataLoaded.some((row: any) =>
                        row.energiedaten_waerme_energietraeger_tid_orig === +value &&
                        row.standort_tid_orig === this.props.standortSelected.tid &&
                        data.values.tid !== row.tid)) {
                return 'Der gewählte Energieträger existiert bereits';
            }
        }
        return '';
    }
}
